/*eslint-disable*/
import React, {
  useState,
  useEffect,
  useContext,
  componentDidMount,
} from "react";
import {
  Select,
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";

import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import GoogleMapsAutoComplete from "../../components/GoogleMapsAutoComplete";
import AlertDialog from "../../components/AlertDialog";
import { language, treatment } from "config";
import { makeStyles } from "@material-ui/core/styles";
import UsersCombo from "../../components/UsersCombo";
import { FirebaseContext } from "common";
// react component used to create a calendar with events on it
import { Calendar as BigCalendar, dateFnsLocalizer } from "react-big-calendar";
// dependency plugin for react-big-calendar
// import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import Email from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import ChatIcon from "@material-ui/icons/ChatBubbleOutlineRounded";
import { VideoCall } from "@material-ui/icons";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import DatePicker from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomInput from "components/CustomInput/CustomInput.js";
import { useSelector, useDispatch } from "react-redux";

import Symptoms from "../Symptoms";
// reactstrap components
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  CardTitle,
  CardHeader,
  CardFooter,
  Label,
} from "reactstrap";
const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const events = [
  {
    title: "Conference",
    start: new Date(2022, 2, 20),
    end: new Date(2022, 2, 23),
    serviceType: "",
    specialityType: "",
    description: "",
  },
];
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    alignContent: "center",
  },
  title: {
    color: "#000",
  },
  gridcontainer: {
    alignContent: "center",
  },
  items: {
    margin: 0,
    width: "100%",
  },
  input: {
    fontSize: 18,
    color: "#000",
  },
  inputdimmed: {
    fontSize: 18,
    color: "#737373",
  },
  practicephoto: {
    height: "18px",
    marginRight: "10px",
  },
  buttonStyle: {
    margin: 0,
    width: "100%",
    height: "100%",
  },
}));

export default function CreateBooking(props) {
  const { api } = useContext(FirebaseContext);
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    fetchUser,
    fetchUsers,

    cancelBooking,
    updateBooking,
  } = api;
  const dispatch = useDispatch();
  const practicetypes = useSelector((state) => state.practicetypes.practices);
  const doctortypes = useSelector((state) => state.doctortypes.doctortypes);
  const [open, setOpen] = useState(false);
  const specialitytypes = useSelector(
    (state) => state.specialitytypes.specialities
  );
  const estimatedata = useSelector((state) => state.estimatedata);
  const bookingdata = useSelector((state) => state.bookingdata);
  const userdata = useSelector((state) => state.usersdata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const medical = useSelector(
    (state) => state.medicalRecords.medicalHistoryRecords
  );

  const [specialityType, setSpecialityType] = useState("");
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [estimateModalStatus, setEstimateModalStatus] = useState(false);
  const [selectedPracticeDetails, setSelectedPracticeDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [userCombo, setUserCombo] = useState(null);

  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(GetDateString());
  const [selectedEndDate, setSelectedEndDate] = useState(GetDateString());
  const auth = useSelector((state) => state.auth);

  const [bookingTypes, setBookingTypes] = useState("");

  const usersdata = useSelector((state) => state.doctors);

  const [serviceTypes, setServiceTypes] = useState("");
  const [description, setDescription] = useState("");
  const classes = useStyles();
  const [specialityTypes, setSpecialityTypes] = useState(null);
  const [newEvent, setNewEvent] = useState({
    title: bookingTypes,
    start: new Date(),
    end: new Date(),
    service: serviceTypes,
    practice: selectedPracticeDetails,
    description: description,
  });

  // console.log(bookingData);
  const [allEvents, setAllEvents] = useState(events);
  const [openFPModal, setOpenFPModal] = React.useState(false);

  const handleAddEvent = () => {
    setAllEvents([...allEvents, newEvent]);
    //todo dispatch create booking use newEvent as payload
    let bookingData = newEvent;
    // console.log(bookingData);
    dispatch(addBooking(bookingData));
  };

  const eventColors = (event, start, end, isSelected) => {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor,
    };
  };
  const handleSpecialitySelect = (event) => {
    setSpecialityType(event.target.value);
    let practiceDetails = null;
    for (let i = 0; i < practicetypes.length; i++) {
      practiceDetails = practicetypes[i];
    }

    setSelectedPracticeDetails(practiceDetails);
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === "Book Later") {
      setSelectedStartDate(GetDateString());
      setSelectedEndDate(GetDateString());
    }
  };

  const onDateStartChange = (event) => {
    setSelectedStartDate(event.target.value);
  };
  const onDateEndChange = (event) => {
    setSelectedEndDate(event.target.value);
  };

  useEffect(() => {
    if (userdata.users.length === 0) {
      dispatch(fetchUsers());
    }
  }, []);

  useEffect(() => {
    console.log("checking for nophone patients", userdata.users);
    if (estimatedata.estimate && estimateRequested) {
      setEstimateRequested(false);
      setEstimateModalStatus(true);
    }
    if (userdata.users) {
      let arr = [];

      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.userType === "patient" || user.userType === "nophonepatient") {
          arr.push({
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            uid: user.id,
            profile_image: user.profile_image,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              user.mobile +
              ") " +
              user.email,
            pushToken: user.pushToken,
          });
        }
      }
      setUsers(arr);
      console.log("UserData", arr);
    }
  }, [estimatedata.estimate, userdata.users, estimateRequested]);

  const handleGetEstimate = (e) => {
    e.preventDefault();

    console.log(selectedPracticeDetails);
    console.table(pickupAddress);
    console.table(dropAddress);
    console.log(selectedPracticeDetails);
    setEstimateRequested(true);
    if (userCombo && selectedPracticeDetails && newEvent.service) {
      if (bookingType === "Book Now") {
        dispatch(
          getEstimate({
            pickup: pickupAddress,
            drop: dropAddress,
            practiceDetails: selectedPracticeDetails,
            serviceType: newEvent.service,
          })
        );
      } else {
        if (
          bookingType === "Book Later" &&
          selectedStartDate &&
          newEvent.service
        ) {
          if (MinutesPassed(selectedStartDate) >= 15) {
            console.log({
              pickup: pickupAddress,
              drop: dropAddress,
              practiceDetails: selectedPracticeDetails,
              serviceType: newEvent.service,
            });
            dispatch(
              getEstimate({
                pickup: pickupAddress,
                drop: dropAddress,
                practiceDetails: selectedPracticeDetails,
                serviceType: newEvent.service,
              })
            );
            console.table("got estimate", estimatedata);
          } else {
            setCommonAlert({ open: true, msg: language.past_booking_error });
          }
        } else {
          setCommonAlert({ open: true, msg: language.select_proper });
        }
      }
    } else {
      setCommonAlert({ open: true, msg: language.select_proper });
    }
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);

    let bookingObject = {
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      pickup: pickupAddress,
      drop: dropAddress,
      practiceDetails: selectedPracticeDetails,
      Medical_Information: medical,
      status: "NEW",
      userDetails: {
        uid: userCombo.uid,
        profile: {
          firstName: userCombo.firstName,
          lastName: userCombo.lastName,
          mobile: userCombo.mobile,
          pushToken: userCombo.pushToken,
          email: userCombo.email,
          profile_image: userCombo.profile_image,
        },
      },
      doctor: "",
      nurse: "",
      estimate: estimatedata.estimate,

      eventdate: new Date(selectedStartDate).toString(),
      bookLater: bookingType === "Book Later" ? true : false,
      settings: settings,
      serviceType: newEvent.service,
      bookingName: newEvent.title,
      description: newEvent.description,
      booking_type_web: true,
      
      markedDot: {
        date: `${moment(selectedStartDate).format("YYYY")}-${moment(
          selectedStartDate
        ).format("MM")}-${moment(selectedStartDate).format("DD")}`,
        dots: [
          {
            key: uuidv4(),
            color: "#ff0000",
            selectedDotColor: "#ff0000",
          },
        ],
      },
    };
    console.log(bookingObject);
    dispatch(addBooking(bookingObject));
    setOpen(true);
  };

  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingAlertClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    dispatch(clearEstimate());
    clearForm();
  };

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setNewEvent({ description: null, title: null });
    setDropAddress(null);
    setSelectedPracticeDetails(null);
    setSpecialityType(language.select_practice);
    setBookingType(language.book_now);
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  return (
    <div className={classes.container}>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography component="h1" variant="h5" className={classes.title}>
              {language.addbookinglable}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {users ? (
              <UsersCombo
                className={classes.items}
                placeholder={"Select a Patient"}
                users={users}
                value={userCombo}
                onChange={(event, newValue) => {
                  setUserCombo(newValue);
                }}
              />
            ) : null}
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomInput
              labelText={"Booking Name"}
              formControlProps={{
                fullWidth: true,
              }}
              type="text"
              placeholder="Add Booking Name"
              onChange={(e) =>
                setNewEvent({
                  ...newEvent,
                  title: e.target.value,
                })
              }
              value={newEvent.title}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomInput
              labelText={"Description"}
              formControlProps={{
                fullWidth: true,
              }}
              type="text"
              placeholder="Add Description"
              onChange={(e) =>
                setNewEvent({
                  ...newEvent,
                  description: e.target.value,
                })
              }
              value={newEvent.description}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="practice-type-native">Practice Type</InputLabel>
              {specialitytypes ? (
                <Select
                  id="practice-type-native"
                  value={specialityType}
                  onChange={handleSpecialitySelect}
                  variant="outlined"
                  fullWidth
                  className={
                    specialityType === language.select_practice
                      ? classes.inputdimmed
                      : classes.input
                  }
                >
                  {specialitytypes.map((speciality) => {
                    console.log(speciality);
                    return (
                      <MenuItem key={speciality} value={speciality}>
                        {/* <img
                        src={practice.image}
                        className={classes.practicephoto}
                        alt="practice types"
                      /> */}
                        {speciality}
                      </MenuItem>
                    );
                  })}
                </Select>
              ) : null}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="booking-type-native">Booking Type</InputLabel>
              <Select
                id="booking-type-native"
                value={bookingType}
                onChange={handleBookTypeSelect}
                className={classes.input}
                variant="outlined"
                fullWidth
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem key={"Book Now"} value={"Book Now"}>
                  {language.book_now}
                </MenuItem>
                <MenuItem key={"Book Later"} value={"Book Later"}>
                  {language.book_later}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel id="service-type-native">Service Type</InputLabel>
              <Select
                id="service-type-native"
                value={newEvent.service}
                onChange={(e) =>
                  setNewEvent({
                    ...newEvent,
                    service: e.target.value,
                  })
                }
                className={classes.input}
                variant="outlined"
                fullWidth
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem key={"videoconference"} value={"Video Conference"}>
                  {language.Video_Conference}
                </MenuItem>
                <MenuItem key={"Home Consultation"} value={"Home Consultation"}>
                  {language.Home_Consultation}
                </MenuItem>
                <MenuItem
                  key={"medicationdelivery"}
                  value={"Medication Delivery"}
                >
                  {language.Medication_Delivery}
                </MenuItem>
                <MenuItem
                  key={"Surgery Consultation "}
                  value={"Surgery Consultation "}
                >
                  {language.Surgery_Patient}
                </MenuItem>

                <MenuItem
                  key={"Antenatal Care Assessment A"}
                  value={"Antenatal Care Assessment A"}
                >
                  {language.antenatal_care_assesment_a}
                </MenuItem>
                <MenuItem
                  key={"Antenatal Care Assessment B"}
                  value={"Antenatal Care Assessment B"}
                >
                  {language.antenatal_care_assesment_b}
                </MenuItem>
                <MenuItem
                  key={"Antenatal Care Assessment C"}
                  value={"Antenatal Care Assessment C"}
                >
                  {language.antenatal_care_assesment_c}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {newEvent.service === "Home Consultation" ||
          newEvent.service === "Medication Delivery" ? (
            <>
              <Grid item xs={12}>
                <GoogleMapsAutoComplete
                  variant={"outlined"}
                  placeholder={language.pickup_location}
                  value={pickupAddress}
                  className={classes.items}
                  onChange={(value) => {
                    setPickupAddress(value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <GoogleMapsAutoComplete
                  placeholder={language.drop_location}
                  variant={"outlined"}
                  value={dropAddress}
                  className={classes.items}
                  onChange={(value) => {
                    setDropAddress(value);
                  }}
                />
              </Grid>
            </>
          ) : null}

          {bookingType === "Book Later" ? (
            <Grid item xs={12} sm={6}>
              <TextField
                id="datetime-local"
                label={language.booking_end_date_time}
                type="datetime-local"
                variant="outlined"
                fullWidth
                className={classes.commonInputStyle}
                InputProps={{
                  className: classes.input,
                }}
                value={selectedStartDate}
                onChange={onDateStartChange}
              />
            </Grid>
          ) : null}
          {bookingType === "Book Later" ? (
            <Grid item xs={12} sm={6}>
              <TextField
                id="datetime-local"
                label={language.booking_start_date_time}
                type="datetime-local"
                variant="outlined"
                fullWidth
                className={classes.commonInputStyle}
                InputProps={{
                  className: classes.input,
                }}
                value={selectedEndDate}
                onChange={onDateEndChange}
              />
            </Grid>
          ) : null}
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Button
          size="large"
          onClick={handleGetEstimate}
          variant="contained"
          color="primary"
          className={classes.buttonStyle}
        >
          <i className="fas fa-practice" />
          {language.book}
        </Button>
      </Grid>
      <Dialog
        open={estimateModalStatus}
        onClose={handleEstimateModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"You are making a booking"}
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={handleEstimateModalClose} color="primary">
            {language.cancel}
          </Button>
          <Button onClick={confirmBooking} color="primary" autoFocus>
            {"Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
      <AlertDialog
        open={bookingdata.booking ? true : false}
        onClose={handleBookingAlertClose}
      >
        {bookingdata.booking
          ? language.booking_success + bookingdata.booking.booking_id
          : null}
      </AlertDialog>
      <AlertDialog
        open={bookingdata.error.flag}
        onClose={handleBookingErrorClose}
      >
        {bookingdata.error.msg}
      </AlertDialog>
      <AlertDialog
        open={estimatedata.error.flag}
        onClose={handleEstimateErrorClose}
      >
        {estimatedata.error.msg}
      </AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
